import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.5rem',

    '& > :not(:last-child)': {
      marginBottom: '0.5rem'
    }
  },

  title: {}
}))

export default useStyles
